/* eslint-disable @typescript-eslint/no-explicit-any */
import { Address, OperationalModel } from '~types/index'

interface ShouldAddAddressIdToCartProps {
  address?: Address
  operationalModel?: OperationalModel
  cart?: any
}

const shouldAddAddressIdToCart = ({
  cart,
  address,
  operationalModel,
}: ShouldAddAddressIdToCartProps) => {
  const isCartWithoutAddress = cart?.id && cart?.customer && !cart?.address
  const hasStoredAddressId = address?.id
  const isDeliveryModel =
    cart?.operationalModel === 'DELIVERY' &&
    operationalModel?.opsModel === 'DELIVERY'
  return Boolean(hasStoredAddressId && isCartWithoutAddress && isDeliveryModel)
}

export default shouldAddAddressIdToCart
